import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, HostListener, Inject, inject, NgZone, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './_components/header/header.component';
import { DrawerComponent, DrawerSelectEvent, KENDO_DRAWER } from '@progress/kendo-angular-layout';
import { homeIcon, imageEditIcon, listUnorderedOutlineIcon, SVGIcon, uploadIcon, userIcon } from '@progress/kendo-svg-icons';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { CommonModule } from '@angular/common';
import { BreadcrumbService } from './_services/breadcrumb.service';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { filter, Subject, takeUntil } from 'rxjs';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { LoginComponent } from "./_components/login/login.component";
import { HeaderService } from './_services/header.service';
import { emptyHeaderToggleI, HeaderToggleI } from './_models/header_objects';
import { SubjectService } from './_services/subject.service';
import { NonAuthorizedComponent } from './_components/errors/non-authorized/non-authorized.component';
import { submittalsIcon } from '../assets/icons/custom-svg-icons';
import { AccountNotFoundComponent } from './_components/errors/account-not-found/account-not-found.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent, KENDO_DRAWER, KENDO_SVGICON, CommonModule, LoginComponent, NonAuthorizedComponent,AccountNotFoundComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck {

  breadCrumpService = inject(BreadcrumbService);
  @ViewChild('drawer', { static: true })
  drawer!: DrawerComponent;
  public selected = "Inbox";
  public items: Array<any> = [];

  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  currentPath: any;
  oldIndex: number = 0;
  newIndex: number = 0;
  index = false;
  userType = '';
  userData: HeaderToggleI = emptyHeaderToggleI();
  public submittalsIcon: SVGIcon = submittalsIcon;
  url = '';
  accountNotFound = false;
  isInitializing = true;

  constructor(private router: Router, private route: ActivatedRoute, private sub: SubjectService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private service: HeaderService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    this.items = [
      { text: "Home", svgIcon: homeIcon, selected: false, path: 'home' },
      { text: "Upload", svgIcon: uploadIcon, selected: false, path: 'upload' },
      { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
      { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
      { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
      { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' }
    ];
    const cachedUserData = sessionStorage.getItem('userData');
    if (cachedUserData) {
      this.userData = JSON.parse(cachedUserData);
      this.sendUserData(this.userData);
      this.addOrRemoveAdmin(this.userData, this.items);
      this.isInitializing = false;
    } else {
      this.fetchToggle();
    }

    for (let i = 0; i < this.items.length; i++) {
      if (window.location.href.split('/')[window.location.href.split('/').length - 1] == this.items[i].path) {
        this.items[i].selected = true;
      }
    }
    let count = 0;
    this.items.forEach(obj => {
      if (obj.selected) {
        count = count + 1;
      }
    });
    if ((this.userType != 'A' && this.userType == '' && window.location.href.split('/')[window.location.href.split('/').length - 1] == 'admin' && count == 0) || (this.userType == 'A' && window.location.href.split('/')[window.location.href.split('/').length - 1] !== 'admin' && count == 0)) {
      // this.items[0].selected = true;
    }
    if (this.userType == 'A' && window.location.href.split('/')[window.location.href.split('/').length - 1] == 'admin') {
      this.items[0].selected = false;
      this.items[6].selected = true;
    }
    if (window.location.href.split('/').includes('submittals')) {
      this.items[5].selected = true;
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  @HostListener('window:load', ['$event'])
  handleLoad(event: Event): void {
    //this.fetchToggle();
    this.service.getLoginUserInfo().subscribe({ next: (res) =>{
      this.userData = res;
      sessionStorage.setItem('userData', JSON.stringify(res));
      if (this.userData.enabled == 'F') {
        this.router.navigate(['non-authorized']);
      } else {
        if (this.router.url == '/non-authorized') {
          this.router.navigate(['home']);
        }
      }

      this.isInitializing = false;
      this.cdr.markForCheck();
    },error: (err) => {
        this.isInitializing = false;
        if (err?.status === 409) {
          // Clean state
          this.userData = emptyHeaderToggleI();
          sessionStorage.removeItem('userData');
          this.accountNotFound = true;

          // Optional: reset nav items
          this.items = [];
          this.cdr.markForCheck();
          this.router.navigate(['account-not-found'])
          return;
        }

        // Handle other errors if needed
        console.error('handleLoad error:', err);
      }
  });

  }

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe();
    this.isIframe = window !== window.parent && !window.opener;
    this.setLoginDisplay();
    this.authService.instance.enableAccountStorageEvents();
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

  }



  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.userData.enabled == 'F') {
      this.items = [];
    }
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);


    }
  }

  public onSelect(ev: DrawerSelectEvent): void {
    this.breadCrumpService.resetCrumb();
    this.router.navigate([`./${ev.item.path}`], { relativeTo: this.route });
  }

  toggleDrawer(event: any) {
    this.drawer.toggle();
  }
  getItem(e: string) {
    this.getOldIndex();
    if (e) {
      this.items[0].selected = true;
      this.newIndex = 0;
      this.selectTab();
    }
  }
  refresh(e: string) {
    this.sub.refreshTrigger$.next(this.url);
  }
  updateSelected(str: string) {
    this.items.forEach(item => item.selected = false);
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].text == str) {
        this.items[i].selected = true;
        this.oldIndex = this.newIndex;
        this.newIndex = i;
        this.selectTab();
      }
    }
  }
  ngDoCheck(): void {
    this.url = window.location.href.split('/')[window.location.href.split('/').length - 1];
    setTimeout(() => {
      this.getTabSelected();
    }, 1500);
    this.sub.leaveSubject.subscribe(res => {   
      if (res == true && this.router.url == '/upload' && this.oldIndex == 4) {
        this.oldIndex = 1;
        this.newIndex = 4;
        this.selectTab();
      }
    });

    if (this.router.url == '/upload') {
      this.sub.cancelSubject.subscribe(res => {
        if (res == true) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].selected == true) {
              this.oldIndex = i;
              this.newIndex = 1;
              this.selectTab();
            }
          }
          let len = this.items.length;
          if (len == 6) {
            this.items = [
              { text: "Home", svgIcon: homeIcon, selected: false, path: 'home' },
              { text: "Upload", svgIcon: uploadIcon, selected: true, path: 'upload' },
              { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
              { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
              { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
              { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' },
            ];
          } if (len == 7) {
            this.items = [
              { text: "Home", svgIcon: homeIcon, selected: false, path: 'home' },
              { text: "Upload", svgIcon: uploadIcon, selected: true, path: 'upload' },
              { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
              { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
              { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
              { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' },
              { text: "Admin", svgIcon: userIcon, selected: false, path: 'admin' },
            ];
          }
        }
      });

    }

  }
  getTabSelected() {
    
    //console.log("this.items",this.items);
    if(this.items.length>0){
    if (this.items[2].selected == true) {
      if (this.router.url == '/orders') {
        this.items[2].selected = false;
        this.items[3].selected = true;
        this.oldIndex = 2;
        this.newIndex = 3;
        this.selectTab();
      }
    }
    if (this.items[3].selected == true) {
      if (this.router.url == '/drafts') {
        this.items[3].selected = false;
        this.items[4].selected = true;
        this.oldIndex = 3;
        this.newIndex = 4;
        this.selectTab();
      }
      if (this.router.url == '/submittals') {
        this.items[3].selected = false;
        this.items[5].selected = true;
        this.oldIndex = 3;
        this.newIndex = 5;
        this.selectTab();
      }
    }
    if (this.items[4].selected == true) {
      if (this.router.url == '/upload') {
        this.items[4].selected = false;
        this.items[1].selected = true;
        this.oldIndex = 4;
        this.newIndex = 1;
        this.selectTab();
      }
    }
    if (this.items[1].selected == true) {
      if (this.router.url.includes('/submittals')) {
        this.items[1].selected = false;
        this.items[5].selected = true;
        this.oldIndex = 1;
        this.newIndex = 5;
        this.selectTab();
      }
    }
  }
  }
  getOldIndex() {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].selected == true) {
        this.oldIndex = i;
      }
    }
    this.items.forEach(item => item.selected = false);
  }
  selectTab() {
    var drawer = document.getElementsByTagName('kendo-drawer')[0];
    var div = drawer.getElementsByTagName('div')[0];
    var ul = div.getElementsByTagName('ul')[0];
    let element = ul.getElementsByTagName('li')[this.oldIndex];
    element?.classList?.remove('k-selected');
    var li = ul.getElementsByTagName('li')[this.newIndex];
    li.classList?.add('k-drawer-item', 'k-selected');
  }

  sendUserData(userData: any) {
    this.service.sendData(userData);
  }

  fetchToggle() {
    this.service.fetchToggle().subscribe({ next: (res) =>{
      let items = this.items;
      this.userType = res.usertype;
      this.userData = res;
      sessionStorage.setItem('userData', JSON.stringify(res));
      this.sendUserData(this.userData);
      this.addOrRemoveAdmin(res, items);
      if (res.usertype !== 'A') {
        this.items = items;
        this.cdr.markForCheck();
      } else {
        if (window.location.href.split('/')[window.location.href.split('/').length - 1] == 'admin' && res.usertype == 'A') {
          if (!this.items.filter(obj => obj.text == 'Admin').length) {
            this.items = items.concat({ text: "Admin", svgIcon: userIcon, selected: true, path: 'admin', cssClass: 'drawer-hide' });
          }
        } else {
          if (!this.items.filter(obj => obj.text == 'Admin').length) {
            this.items = items.concat({ text: "Admin", svgIcon: userIcon, selected: false, path: 'admin', cssClass: 'drawer-hide' });
          }
        }
        if ((this.userType == 'A' && window.location.href.split('/')[window.location.href.split('/').length - 1] == 'admin')) {
          this.items = [
            { text: "Home", svgIcon: homeIcon, selected: false, path: 'home' },
            { text: "Upload", svgIcon: uploadIcon, selected: false, path: 'upload' },
            { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
            { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
            { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
            { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' },
            { text: "Admin", svgIcon: userIcon, selected: true, path: 'admin' },
          ];
        }
        this.isInitializing = false;
        this.cdr.markForCheck();
      }


    },error: (err) => {
        this.isInitializing = false;
        if (err?.status === 409) {
          // Clean state
          
          sessionStorage.removeItem('userData');
          this.accountNotFound = true;

          // Optional: reset nav items
          this.items = [];
          this.cdr.markForCheck();
          this.router.navigate(['account-not-found'])
          return;
        }

        // Handle other errors if needed
        console.error('fetchToggle error:', err);
      }
  });

  }

  addOrRemoveAdmin(res: any, items: any) {
    this.userType = res.usertype;
    if (res.usertype !== 'A') {
      this.items = items;
      this.cdr.markForCheck();
    } else {
      if (window.location.href.split('/')[window.location.href.split('/').length - 1] == 'admin' && res.usertype == 'A') {
        if (!this.items.filter(obj => obj.text == 'Admin').length) {
          this.items = items.concat({ text: "Admin", svgIcon: userIcon, selected: true, path: 'admin', cssClass: 'drawer-hide' });
        }
      } else {
        if (!this.items.filter(obj => obj.text == 'Admin').length) {
          this.items = items.concat({ text: "Admin", svgIcon: userIcon, selected: false, path: 'admin', cssClass: 'drawer-hide' });
        }
      }
      if ((this.userType == 'A' && window.location.href.split('/')[window.location.href.split('/').length - 1] == 'admin')) {
        this.items = [
          { text: "Home", svgIcon: homeIcon, selected: false, path: 'home' },
          { text: "Upload", svgIcon: uploadIcon, selected: false, path: 'upload' },
          { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
          { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
          { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
          { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' },
          { text: "Admin", svgIcon: userIcon, selected: true, path: 'admin' },
        ];
      }
      this.cdr.markForCheck();
    }

  }


  ngAfterViewInit(): void {
    setTimeout((
    ) => {
      if (!this.items.filter(obj => obj.selected).length && this.userType == 'A') {
        this.items = [
          { text: "Home", svgIcon: homeIcon, selected: true, path: 'home' },
          { text: "Upload", svgIcon: uploadIcon, selected: false, path: 'upload' },
          { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
          { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
          { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
          { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' },
          { text: "Admin", svgIcon: userIcon, selected: false, path: 'admin', cssClass: 'drawer-hide' }
        ];
      } else {
        if (!this.items.filter(obj => obj.selected).length && this.userType !== 'A') {
          this.items = [
            { text: "Home", svgIcon: homeIcon, selected: true, path: 'home' },
            { text: "Upload", svgIcon: uploadIcon, selected: false, path: 'upload' },
            { text: "Projects", svgIcon: imageEditIcon, selected: false, path: 'projects' },
            { text: "Orders", svgIcon: listUnorderedOutlineIcon, selected: false, path: 'orders' },
            { text: "Drafts", svgIcon: uploadIcon, selected: false, path: 'drafts' },
            { text: "Submittals", svgIcon: this.submittalsIcon, selected: false, path: 'submittals' }
          ];
        }
      }
      this.cdr.markForCheck();
    }, 1000);
  }
}
